/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import TimeAndModel from '../components/TimeAndModel';
import Footer from '../components/Footer';

import useCarsData from '../hooks/useCarsData';
import useStationsData from '../hooks/useStationsData';
import useConfigData from '../hooks/useConfigData';
import useSocialMediaData from '../hooks/useSocialMediaData';
import useLegalUrl from '../hooks/useLegalUrl';
import useModelUrl from '../hooks/useModelUrl';
import TwoStepForm from '../components/TwoStepForm';

const Cotizador = ({legal_url_path, model_url_path, car_id, uf_value}) => {
    const { getCars, setSelectedCar, cars } = useCarsData();
    const { getConfig } = useConfigData();
    const {setModelUrl, model_url} = useModelUrl();
    const {setLegalUrl} = useLegalUrl();
    const {getSocialMedia } = useSocialMediaData();
    const { getStations } = useStationsData();


    useEffect(() => {
        getCars();
        getStations();
        getConfig();
        setLegalUrl(legal_url_path);
        getSocialMedia()
        setModelUrl(model_url_path);
    }, []);

    useEffect(() => {
        if (car_id && cars.length > 0) {
            setSelectedCar(car_id);
        }
    }, [cars, car_id]);

       
    return (
        <section className='cotizador one_personal' id='cotizador'>
            <div className='container'>
                <TwoStepForm uf_value={uf_value} />
            </div>
        </section>
    );
}

export default Cotizador;
